import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";

export const FooterContainer = styled.footer`
  background: #101522;
`;

export const FooterWrap = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
`;
export const FooterLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
    flex-direction: column;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  box-sizing: border-box;
  color: #fff;
  max-width: 350px;

  @media screen and (max-width: 480px) {
    margin: 0;
    padding: 10px;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 15px;
  margin-bottom: 16px;
`;

export const FooterLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;
  line-height: 1.2rem;
  position: relative;

  &:hover {
    color: #01bf71;
    transition: 0.3s ease-out;
  }
  &::before {
    content: " ";
    position: absolute;
    top: 6px;
    left: -10px;
    width: 4px;
    height: 4px;
    background-color: #01bf71;
    border-radius: 50%;
  }
`;

export const FooterItemContact = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;
export const FooterItemIconContactPhone = styled(FaPhoneAlt)`
  color: white;
  margin-right: 10px;
  font-size: 20px;
`;
export const FooterItemContactText = styled.p`
  @media screen and (max-width: 480px) {
    width: 220px;
    word-wrap: break-word;
    margin: 0;
    padding: 10px;
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const FooterItemIconContactMail = styled(AiOutlineMail)`
  color: white;
  margin-right: 10px;
  font-size: 20px;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 30px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 16px;
`;

export const SocialIcons = styled.div`
  visibility: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
`;
